module.exports = __webpack_public_path__ + "static/img/loading_duiduoduo.ea0a03a9.gif";